// extracted by mini-css-extract-plugin
export default {"addGroup":"FilteringModal_addGroup__MUPQ+","multiSelect":"FilteringModal_multiSelect__6ipmk"};